import { useCallback } from 'react';

import { useDataMutation } from '@work4all/data';

import { Contact } from '@work4all/models/lib/Classes/Contact.entity';
import { Customer } from '@work4all/models/lib/Classes/Customer.entity';
import { InputAnsprechpartnerRelation } from '@work4all/models/lib/Classes/InputAnsprechpartnerRelation.entity';
import { InputKundeRelation } from '@work4all/models/lib/Classes/InputKundeRelation.entity';
import { InputLieferantRelation } from '@work4all/models/lib/Classes/InputLieferantRelation.entity';
import { OutlookAddress } from '@work4all/models/lib/Classes/OutlookAddress.entity';
import { Supplier } from '@work4all/models/lib/Classes/Supplier.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { SdObjType } from '@work4all/models/lib/Enums/SdObjType.enum';

const personalContactMappings: OutlookAddress[] = [
  {
    id: null,
    contactId: null,
    sdObjMemberId: null,
    userId: null,
    user: {
      id: null,
      displayName: null,
    },
    sdObjType: null,
  },
];

const BUSINESSPARTNER_RESPONSE: Customer | Supplier = {
  id: null,
  name: null,
  contactList: [
    {
      id: null,
      displayName: null,
      personalContactMappings,
    },
  ],
  personalContactMappings,
};

const CONTACT_RESPONSE: Contact = {
  id: null,
  displayName: null,
  personalContactMappings,
};

export const usePersonalContactsApi = (props: { entity: Entities }) => {
  const { entity } = props;

  const [mutateBusinessPartner] = useDataMutation<
    Customer | Supplier,
    EMode.upsert,
    InputKundeRelation | InputLieferantRelation
  >({
    entity: entity,
    mutationType: EMode.upsert,
    responseData: BUSINESSPARTNER_RESPONSE,
  });

  const [mutateContact] = useDataMutation<
    Contact,
    EMode.upsert,
    InputAnsprechpartnerRelation
  >({
    entity: Entities.contact,
    mutationType: EMode.upsert,
    responseData: CONTACT_RESPONSE,
  });

  const togglePersonalContact = useCallback(
    async (props: {
      userId: number;
      sdObjMemberId: number;
      contactId?: number;
      state: boolean;
    }) => {
      const { userId, sdObjMemberId, contactId, state } = props;
      if (contactId) {
        return mutateContact(
          {
            id: contactId,
            businessPartnerType:
              entity === Entities.customer
                ? SdObjType.KUNDE
                : SdObjType.LIEFERANT,
          },
          {
            relations: {
              setPersonalContact: [
                {
                  state,
                  userCode: userId,
                },
              ],
            },
          }
        );
      } else {
        return mutateBusinessPartner(
          {
            id: sdObjMemberId,
          },
          {
            relations: {
              setPersonalContact: {
                state,
                userCode: userId,
              },
            },
          }
        );
      }
    },
    [entity, mutateBusinessPartner, mutateContact]
  );

  return { togglePersonalContact };
};
